import React from "react";

interface RequestAQuoteButtonProps {
  requestAQuoteUrl: string | undefined;
}

const RequestAQuoteButton = ({
  requestAQuoteUrl,
}: RequestAQuoteButtonProps) => {
  const href = requestAQuoteUrl ?? "/special-orders/";

  return (
    <a
      href={href}
      type="button"
      className="btn btn-cart btn-small"
      data-testid="request-a-quote-button"
      data-action="addToCart"
    >
      Request a Quote
    </a>
  );
};

export default RequestAQuoteButton;
